import React from 'react'

const Experience = () => {
  return (
    <div>
      <p className='heroHeadings about-text-slide'>I am currently:</p>
      <ul className='list-disc'>
        <li className='inline-flex'>
          <p className='roleText about-text-slide'>•&nbsp; Frontend Software Engineer <a className='aboutLinks' href="https://www.macquarie.com/au/en.html" target="_blank"
          >@ Macquarie Group</a></p>
        </li><br />
        <li className='inline-flex'>
          <p className='roleText about-text-slide'>•&nbsp; Final Year Computer Science <a className='aboutLinks' href="https://au.linkedin.com/school/unsw/" target="_blank"
          >@ UNSW</a></p>
        </li><br />
        <li className='inline-flex'>
          <p className='roleText about-text-slide'>•&nbsp; Software Engineer <a className='aboutLinks' href="https://www.sunswift.com/" target="_blank"
          >@ Sunswift Racing</a></p>
        </li><br />
        <li className='inline-flex'>
          <p className='roleText about-text-slide'>•&nbsp; IT Director <a className='aboutLinks' href="https://www.unswdigitalsociety.org/about" target="_blank"
          >@ UNSW Digital Society </a></p>
        </li><br />
      </ul>

      <p className='heroHeadings about-text-slide'>Previously:</p>
      <ul className='list-disc'>
        <li className='inline-flex'>
          <p className='roleText about-text-slide'>•&nbsp; Software Engineer <a className='aboutLinks' href="https://www.optus.com.au/about/" target="_blank"
          >@ Optus</a></p>
        </li><br />
        <li className='inline-flex'>
          <p className='roleText about-text-slide'>•&nbsp; Product Specialist <a className='aboutLinks' href="https://www.apple.com/au/" target="_blank"
          >@ Apple</a></p>
        </li><br />
      </ul>
    </div>
  )
}

export default Experience